<template>
  <div id="vitamins" class="col-lg-6">
    <div class="col-card mh" style="overflow: hidden">
      <h2>{{ $t('message.vitamins') }}</h2>
      <div class="row vitamin-row align-items-start">
        <div class="w-100 d-flex justify-content-center">
          <generic-chart style="min-height:50vh;"
                         @clickData="openCurrent"
                         v-if="chartLabels.length && chartData.length"
                         :name="'Vitamins'"
                         :chart-labels="chartLabels"
                         :chart-data="[chartData]"></generic-chart>
        </div>
        <div :data-active="activeVitamin" class="col-lg-12 col-xxl-4 m-auto">
          <div class="vitamin-info mt-0">
            <div class="vitamin-info-scores mt-3">
              <div class="vitamin-average">
                <div class="row vitamin-team">
                  <div class="col-md-12 text-center mb-3">{{ $t('message.score') }}</div>
                  <div class="col-md-12 text-center">
                    <div class="score score-medium score-avg"
                         :class="'score-c-'+truncate(score,0)+' score-bc-'+truncate(score,0)">
                      <span :class="score % 1 > 0 ? 'small font-weight-light':''">{{truncate(score,1)}}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import GenericChart from "../Charts/GenericChart";

  export default {
    components: {
      GenericChart
    },
    methods: {
      openCurrent() {
        //console.log('emitting opencurrent')
        this.$emit('openCurrent')
      },
      setActive(i) {
        this.activeVitamin = i
      },
      vitaminScore(vitamin, type = 'average') {
        let score = 0;
        if (this.current.data) {
          const vitaminScores = this.current.data.children;
          for (let key in vitaminScores) {
            if (vitaminScores[key].id === vitamin.id) {
              score = vitaminScores[key][type]
            }
          }
        }

        return this.truncate(score, 2);
      },
      getChartData() {
        if (this.vitamins.length && this.current) {
          this.chartData = [];
          this.chartLabels = [];
          this.vitamins.forEach(vitamin => {
            if(this.vitaminScores[vitamin.id]){
              this.chartData.push(this.vitaminScore(vitamin, 'average'));
              this.chartLabels.push(this.localizedField(vitamin,'Title'))
            }
          });
          this.loadChart = true;
        }
      }
    },
    data() {
      return {
        loadChart: false,
        chartData: [],
        chartLabels: [],
        activeVitamin: 0,
      }
    },
    computed: {
      score() {
        let sc = 0
        if(this.current){
          sc = this.current.vipscore
        }
        return sc;
      }
    },
    mounted() {
      this.getChartData()
    },
    watch: {
      vitamins() {
        this.getChartData()
      }
    },
    created() {
      window.addEventListener("resize", this.resizeHandler);
    },
    destroyed() {
      window.removeEventListener("resize", this.resizeHandler);
    },
    props: {
      current: {
        type: Object,
        default() {
          return null
        }
      },
      vitaminScores: {
        type: Object,
        default() {
          return {}
        }
      },
      vitamins: {
        type: Array,
        default() {
          return []
        }
      }
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Vitamins.vue